import type { ComponentProps as FromAssetLabelProps } from '@exodus/exchange-ui/lib/form/components/from-asset-label';
import type { ComponentProps as ToAssetLabelProps } from '@exodus/exchange-ui/lib/form/components/to-asset-label';
import { formatBalance } from '@exodus/formatting/lib/asset';
import Skeleton from '@passkeys/ui/skeleton';
import Text from '@passkeys/ui/text';

import { cn } from '@/ui/utils/classnames';

type LabelProps = FromAssetLabelProps | ToAssetLabelProps;

function Label(props: LabelProps) {
  const value =
    props.side === 'from'
      ? `I have ${formatBalance(props.balance as any, props.asset)}`
      : `I want ${props.asset.displayTicker}`;

  return (
    <Text
      size={13}
      monospace
      className={cn(
        'truncate text-gray-500 theme-dark:text-neutral-400',
        props.className,
      )}
      dataTestId="swap-form-asset-label"
    >
      {value}
    </Text>
  );
}

export function LabelSkeleton({ className }: Pick<LabelProps, 'className'>) {
  return (
    <div className={className}>
      <Skeleton width={64} height={13} className="my-[2.5px]" />
    </div>
  );
}

export default Label;
